/**
 * Represents weather a string is boolean or not.
 * @param {string} - possible boolean value.
 * @returns {boolean} - Returns the boolean value.
 */
export function convertToBoolean(stringVal) {
    if (stringVal === undefined || stringVal === null) return false;
    switch (stringVal.toLowerCase()) {
        case "1":
            return true;
        case "true":
            return true;
        default: return false;
    }
}

/**
 * Returns the user id from the route, if nothing found then return null
 * @returns {string} 
 */
export function getUserIdFromRoute() {
    const pathname = window.location.pathname;
    const splittedPath = pathname.split("/");

    if (splittedPath.length < 3) return null;

    const userId = Number(splittedPath[3]);
    if (isNaN(userId) || userId === 0 || userId === undefined) return null;

    return userId;
};

/**
 * 
 * @param {string} url 
 * @returns a shorter version of the url
 */
export const urlShortner = function (url) {
    if (url.length > 20) return url.substr(0, 25) + '...';
};